const ROOT_SELECTOR = '[data-protocol-pairing]';
const TAB_SELECTOR = '[data-protocol-tab]';

/**
 * @param {HTMLElement} root
 */
function initProtocolPairing(root) {
  const tabs = /** @type {NodeListOf<HTMLButtonElement>} */ (root.querySelectorAll(TAB_SELECTOR));
  if (!tabs.length) return;

  /**
   * @param {HTMLButtonElement} btn
   * @returns {HTMLElement | null}
   */
  function panelForTab(btn) {
    const panelId = btn.getAttribute('aria-controls');
    if (!panelId) return null;
    if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
      return root.querySelector(`#${CSS.escape(panelId)}`);
    }
    return root.querySelector(`[id="${panelId.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"]`);
  }

  /**
   * @param {HTMLButtonElement} activeBtn
   */
  function visiblePanelIndexes(activeIndex) {
    // Always show only the active panel regardless of viewport
    return [activeIndex];
  }

  function activate(activeBtn) {
    const activeIndex = Array.from(tabs).indexOf(activeBtn);
    const visibleIndexes = visiblePanelIndexes(activeIndex);

    tabs.forEach((btn, index) => {
      const on = btn === activeBtn;
      const panel = panelForTab(btn);
      const isVisible = visibleIndexes.includes(index);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', String(on));
      btn.setAttribute('tabindex', on ? '0' : '-1');
      if (panel) {
        panel.classList.toggle('protocol-pairing__panel--hidden', !isVisible);
        panel.classList.toggle('is-active', on);
        panel.setAttribute('aria-hidden', String(!isVisible));
      }
    });
  }

  function refreshVisiblePanels() {
    const activeBtn = root.querySelector('.protocol-pairing__tab.is-active');
    if (activeBtn) activate(activeBtn);
  }

  const mediaQuery = window.matchMedia('(min-width: 1000px)');
  mediaQuery.addEventListener?.('change', refreshVisiblePanels);

  let startIdx = Number(root.dataset.defaultTabIndex || '0');
  if (startIdx < 0 || startIdx >= tabs.length) startIdx = 0;
  const startBtn = tabs[startIdx] || tabs[0];
  if (startBtn) activate(startBtn);

  tabs.forEach((btn) => {
    btn.addEventListener('click', () => activate(btn));
  });

  const tablist = root.querySelector('[role="tablist"]');
  tablist?.addEventListener('keydown', (e) => {
    const key = /** @type {KeyboardEvent} */ (e);
    const target = /** @type {HTMLElement | null} */ (key.target);
    if (!target?.matches(TAB_SELECTOR)) return;

    const current = /** @type {HTMLButtonElement} */ (target);
    const i = Array.from(tabs).indexOf(current);
    if (i === -1) return;

    const nav = { ArrowLeft: -1, ArrowRight: 1, Home: -i, End: tabs.length - 1 - i };
    const off = nav[/** @type {keyof typeof nav} */ (key.key)];
    if (off === undefined) return;

    key.preventDefault();
    const next = (i + off + tabs.length) % tabs.length;
    const nextBtn = tabs[next];
    if (nextBtn) {
      activate(nextBtn);
      nextBtn.focus();
    }
  });
}

function initAll() {
  document.querySelectorAll(ROOT_SELECTOR).forEach((el) => initProtocolPairing(/** @type {HTMLElement} */ (el)));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}
